import React from 'react'
import './services.css'
import {servicesData} from './Data'

const Services = () => {
    return (
    <>
        <section className="services section" id="services">
            <h2 className="section__title">Services</h2>
            <span className="section__subtitle">What I Offer</span>

            <div className="services__container container grid section__border">
                {
                    servicesData.map((item,index)=>{
                        return(
                            <div className="services__card" key={index}>
                                <i className={item.Icon}></i>
                                <h2 className="services__title">
                                    {item.NameFirst} <br/>
                                    {item.NameLast}
                                </h2>

                                <p>
                                    {item.Describe}
                                </p>
                                
                                <div className="services__border services__border-eng">
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </section>
    </>
    )
}

export default Services